import type { TaskStatusKey } from '../../../api/scraping';

export enum ScrapingStatus {
  SUBMITTED = 'SUBMITTED',
  PENDING = 'PENDING',
  IN_PROCESS = 'IN_PROCESS',
  IN_PROCESS_PARSING = 'IN_PROCESS_PARSING',
  IN_PROCESS_KNOWLEDGE = 'IN_PROCESS_KNOWLEDGE',
  IN_PROCESS_DEMO = 'IN_PROCESS_DEMO',
  SUCCESS = 'SUCCESS',
  SUCCESS_PARSING = 'SUCCESS_PARSING',
  SUCCESS_KNOWLEDGE = 'SUCCESS_KNOWLEDGE',
  SUCCESS_DEMO = 'SUCCESS_DEMO',
  FAILURE = 'FAILURE',
  FAILURE_PARSING = 'FAILURE_PARSING',
  FAILURE_KNOWLEDGE = 'FAILURE_KNOWLEDGE',
  FAILURE_DEMO = 'FAILURE_DEMO',
  REVOKED = 'REVOKED',
  RETRY = 'RETRY',
  STARTED = 'STARTED',
  UNKNOWN = 'UNKNOWN',
}

const successStatuses: ScrapingStatus[] = [
  ScrapingStatus.SUCCESS,
  ScrapingStatus.SUCCESS_PARSING,
  ScrapingStatus.SUCCESS_KNOWLEDGE,
  ScrapingStatus.SUCCESS_DEMO,
];

export const SUCCESS_STATUS_SET = new Set<string>(successStatuses);

export const isSuccessStatus = (status?: string | null): boolean => {
  if (!status) {
    return false;
  }

  return SUCCESS_STATUS_SET.has(status.toUpperCase());
};

const deletableStatuses: ScrapingStatus[] = [
  ScrapingStatus.SUCCESS,
  ScrapingStatus.SUCCESS_PARSING,
  ScrapingStatus.SUCCESS_KNOWLEDGE,
  ScrapingStatus.SUCCESS_DEMO,
  ScrapingStatus.FAILURE,
  ScrapingStatus.FAILURE_PARSING,
  ScrapingStatus.FAILURE_KNOWLEDGE,
  ScrapingStatus.FAILURE_DEMO,
  ScrapingStatus.REVOKED,
];

export const DELETABLE_STATUS_SET = new Set<string>(deletableStatuses);

export const isDeletableStatus = (status?: string | null): boolean => {
  if (!status) {
    return false;
  }

  return DELETABLE_STATUS_SET.has(status.toUpperCase());
};

export enum OutputMode {
  FLAT_FILE = 'FLAT_FILE',
  ARCHIVE = 'ARCHIVE',
}

export enum ScrapingDepthType {
  ONE_PAGE = 'ONE_PAGE',
  ALL_PAGES = 'ALL_PAGES',
}

export const outputModeOptions: Array<OptionType> = [
  { label: 'Flat File', value: OutputMode.FLAT_FILE },
  { label: 'Archive', value: OutputMode.ARCHIVE },
];

export const depthTypeOptions: Array<OptionType> = [
  { label: 'One page only', value: ScrapingDepthType.ONE_PAGE },
  { label: 'All pages on the site', value: ScrapingDepthType.ALL_PAGES },
];

export const sliderStepOptions = ['0', '1', '2', '3', '4', '5', '∞'];

export const pageLimitStepOptions = [
  '1',
  '500',
  '1000',
  '2500',
  '5000',
  '10000',
];

export const filterStatusOptions: Array<
  OptionType<TaskStatusKey | 'IN_PROCESS' | ''>
> = [
  { value: '', label: 'All' },
  { value: 'SUCCESS', label: 'Success' },
  { value: 'RETRY', label: 'Retry' },
  { value: 'IN_PROCESS', label: 'In progress' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'FAILURE', label: 'Failed' },
];
